"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CATEGORY_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
exports.CATEGORY_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment Category on Category {\n    id\n    name\n    parent {\n      id\n      name\n    }\n  }\n"], ["\n  fragment Category on Category {\n    id\n    name\n    parent {\n      id\n      name\n    }\n  }\n"])));
var templateObject_1;
